import React, { useState } from 'react'
import ShowProductView from './ShowProductView'

const ShowProductApp = (props) => {
  const [isEditing, setIsEditing] = useState(false)
  const passEditState = (val) => {
    setIsEditing(val)
  }

  return (
    <ShowProductView
      editStateChanged={passEditState}
      isEditing={isEditing}
      successCreateForNewProduct={props.successCreateForNewProduct}
    />
  )
}

export default ShowProductApp
